import React from 'react'
import { 
  Delimiter,
  InnerContainer,
  LogoHolder,
  StyledMintComponent,
  Trailer,
  TrailerControls,
  TrailerContainer,
  TrailerText
} from "./Mint.styled"
import { PlayVideo, Megalogo } from '../';
import VerticalTicker from './MintTicker'
import MintFigures from './MinFigures'
import MintEquipment from './MintEquipment'
import FooterMap from './FooterMap'
import { Panel, PanelHolder, PanelImage } from './MintActionFigures.styled'
import useIsMobile from '../../hooks/useIsMobile';

export default function MintComponent() {
  const isMobile = useIsMobile();
  return (
    <StyledMintComponent>
	  {/*<MintActionFigures />*/}
      <InnerContainer>
        <PanelHolder>
          <Delimiter />
          {isMobile &&
            <Panel>
              <PanelImage src="/assets/panel_top.png"/>
            </Panel>
          }
        </PanelHolder>
        {!isMobile && <>
          <TrailerContainer>
            <Trailer src="/assets/basejump_homepage_2024_2.webm" autoPlay loop muted={true}/>
            <TrailerText>
              BROADSIDE: BATTLE MODE is the first game built on Basejump - a new platform where you can make, play, discover and monetize games instantly. 
            </TrailerText>
          </TrailerContainer>
          <Delimiter />
          <Panel>
            <PanelImage src="/assets/panel_top.png"/>
          </Panel>
          <VerticalTicker />
	</>}
        <MintFigures />
        <MintEquipment />
        <PanelHolder>
          <Panel>
            <PanelImage src="/assets/panel_bottom.png"/>
          </Panel>
          <Delimiter />
        </PanelHolder>
      </InnerContainer>
      
      <FooterMap />
    </StyledMintComponent>
  )
}
